<ng-container
  *ngIf="
    containerClass === 'container' || containerClass === 'container--wide';
    else fullWidthBlock
  "
>
  <div edsGrid>
    <div [class]="containerClass">
      <ng-container *ngIf="canShowForm">
        <div edsRow>
          <div edsCol>
            <eds-cta
              [theme]="backgroundTheme"
              [edsSpacing]="
                marginBottom && marginBottom !== 'none' ? marginBottom : 'xl'
              "
              [isAlignContentCenter]="true"
              [removeFlexBox]="true"
              [isMarketoForm]="true"
            >
              <eds-title [title]="title" [theme]="titleColor"></eds-title>
              <div *ngIf="summary">
                <p [innerHtml]="summary | safeHtml"></p>
              </div>
              <eds-marketo-form
                *ngIf="preferencesLoaded"
                [marketoFormConfig]="formConfig"
                [edsSpacing]="disclaimer && disclaimer !== '' ? 'lg' : ''"
                [marketoPreferencesResult]="userSubscriptionData"
                [retainFormAfterSubmission]="retainFormAfterSubmission"
                [mktoFormId]="id"
                [successTitle]="successTitle"
                [successMsg]="successMsg"
                (formSubmit)="formAnalytics()"
                (formClick)="formClickAnalytics()"
                [hasUnsubscribeButton]="hasUnsubscribeButton"
                [unsubscribeButtonText]="unsubscribeButtonText"
                [mktoPrefillData]="prefillData"
                [componentId]="componentId"
                [brDisclaimer]="disclaimer"
                [showButtonUnderneath]="showButtonUnderneath"
              ></eds-marketo-form>
            </eds-cta>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!canShowForm">
        <div [innerHtml]="marketoFormPrivacy | safeHtml"></div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #fullWidthBlock>
  <ng-container *ngIf="canShowForm">
    <eds-cta
      [isAlignContentCenter]="true"
      [isMarketoForm]="true"
      [edsSpacing]="
        marginBottom && marginBottom !== 'none' ? marginBottom : 'xl'
      "
    >
      <eds-title [title]="title" [theme]="titleColor"></eds-title>
      <div *ngIf="summary">
        <p [innerHtml]="summary | safeHtml"></p>
      </div>
      <eds-marketo-form
        *ngIf="preferencesLoaded"
        [marketoFormConfig]="formConfig"
        [edsSpacing]="disclaimer && disclaimer !== '' ? 'lg' : ''"
        [marketoPreferencesResult]="userSubscriptionData"
        [retainFormAfterSubmission]="retainFormAfterSubmission"
        [mktoFormId]="id"
        [successTitle]="successTitle"
        [successMsg]="successMsg"
        (formSubmit)="formAnalytics()"
        [hasUnsubscribeButton]="hasUnsubscribeButton"
        [unsubscribeButtonText]="unsubscribeButtonText"
        [mktoPrefillData]="prefillData"
        [brDisclaimer]="disclaimer"
        [componentId]="componentId"
        [showButtonUnderneath]="showButtonUnderneath"
      ></eds-marketo-form>
    </eds-cta>
  </ng-container>

  <div class="container">
    <ng-container *ngIf="!canShowForm">
      <div [innerHtml]="marketoFormPrivacy | safeHtml"></div>
    </ng-container>
  </div>
</ng-template>
